/* eslint react/prop-types:0 */
import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { BetaFeaturesSiteSettingsPageLoader } from '@confluence/beta-features/entry-points/BetaFeaturesSiteSettingsPage.ts';

export const BetaFeaturesRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <BetaFeaturesSiteSettingsPageLoader />;

BetaFeaturesRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: 'betaFeaturesScreen' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
